import { DaGalleryOptions } from '@wix/da-editor-tiptap/pkg/extensions/extension-gallery/gallery';
import { PapiDeviation } from '@wix/da-papi-types';
import React from 'react';
import { DeviationDuperbrowseContext } from '../../Duperbrowse';
import GalleryGrid from './_partials/GalleryGrid';
import GalleryTorpedo from './_partials/GalleryTorpedo';
import MonoView from '../MonoView';

export interface Props {
  extOptions: DaGalleryOptions;
  width: number;
  deviations: PapiDeviation[];
  layout: 'torpedo' | 'grid';
  layoutSpacing: number | null;
  layoutRowAlignment: 'left' | 'center' | 'right';
  itemCropping: 'crop' | 'fit';
  gridItemWidth: number | null;
  gridItemHeight: number | null;
  torpedoRowHeight: number | null;
  linkOverrides: Record<number, string>;
}

const GalleryView: React.FC<Props> = props => {
  const { deviations, layout } = props;
  const isSingle = deviations.length === 1;
  return (
    <DeviationDuperbrowseContext
      streamId={deviations.reduce(
        (prev, current) => `${prev}-${current.deviationId}`,
        ''
      )}
      deviations={deviations}
    >
      {isSingle && deviations[0] && (
        <MonoView
          {...(props as any)}
          deviation={deviations[0]}
          link={props.linkOverrides?.[deviations[0]?.deviationId] ?? undefined}
        />
      )}
      {!isSingle && layout === 'grid' && <GalleryGrid {...props} />}
      {!isSingle && layout === 'torpedo' && <GalleryTorpedo {...props} />}
    </DeviationDuperbrowseContext>
  );
};
GalleryView.displayName = 'GalleryView';

export default GalleryView;
